import Vue from 'vue'

export const actionEditorDialogs = Vue.observable({ items: [] })

let sequence = 0

export function openActionEditor(options = {}) {
  sequence += 1
  const item = {
    key: `action-editor-${Date.now()}-${sequence}`,
    moduleId: options.moduleId,
    actionId: options.actionId ?? options.id ?? 'new',
    title: options.title || 'Édition de l’action',
    width: options.width || 1000,
    persistent: Boolean(options.persistent),
    onSaved: typeof options.onSaved === 'function' ? options.onSaved : null,
    onClosed: typeof options.onClosed === 'function' ? options.onClosed : null,
  }
  actionEditorDialogs.items.push(item)
  return item.key
}

export function closeActionEditor(key, result = null) {
  const index = actionEditorDialogs.items.findIndex(item => item.key === key)
  if (index === -1) return
  const [item] = actionEditorDialogs.items.splice(index, 1)
  if (item.onClosed) item.onClosed(result)
}

export function notifyActionSaved(key, action) {
  const item = actionEditorDialogs.items.find(dialog => dialog.key === key)
  if (item && item.onSaved) item.onSaved(action)
}

export function actionEditorLocation(options = {}) {
  return {
    name: 'engine-action-edit',
    params: {
      moduleId: options.moduleId,
      id: options.actionId ?? options.id ?? 'new',
    },
  }
}
